import React, { Fragment, useEffect } from "react";
import { connect } from "react-redux";
import { Breadcrumbs, Card, CardContent, Chip, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { getByAreaDataCommon, setCurrentPage } from "actions";
import * as C from "components";
import * as V from "styles/variables";
import CalendarRangePicTreeCommon from "components/Calendar/CalendarRangePicTreeCommon";
import ByAreaSummary from "components/PicTree/Game/Area/ByAreaSummary";
import ByAreaDetailTableCommon from "components/PicTree/Game/Area/ByAreaDetailTableCommon";

const useStyles = makeStyles((theme) => ({
  breadcrumbs: { marginTop: 16, minHeight: 30 },
  gridSection: { marginTop: theme.spacing(1) },
  loaderBox: { width: "100%", minHeight: 280, display: "flex", alignItems: "center", justifyContent: "center" },
  loaderBarImg: { width: 40 },
  noData: { minHeight: 280, display: "flex", alignItems: "center", justifyContent: "center" },
}));

const PicTreePhotoByAreaCommon = ({
  pageTopLoader,
  dateRangePicTreeCommon,
  byAreaDataSummary,
  byAreaDataTable,
  selectedAreaLayerId,
  setCurrentPage,
  getByAreaDataCommon,
}) => {
  const classes = useStyles();
  useEffect(() => {
    setCurrentPage(window.location.pathname);
  }, [setCurrentPage]);

  useEffect(() => {
    if (
      Array.isArray(dateRangePicTreeCommon) &&
      dateRangePicTreeCommon.length === 2 &&
      dateRangePicTreeCommon[0] &&
      dateRangePicTreeCommon[1]
    ) {
      getByAreaDataCommon({ dateRange: dateRangePicTreeCommon, areaLayerId: selectedAreaLayerId });
    }
  }, [dateRangePicTreeCommon, selectedAreaLayerId, getByAreaDataCommon]);

  const hasData = Array.isArray(byAreaDataTable) && byAreaDataTable.length > 0;

  return (
    <Fragment>
      <C.ContentWrapper>
        <Grid
          container
          spacing={0}
          direction="row"
          style={{ marginTop: -16, marginBottom: 8 }}
          justifyContent="space-between"
        >
          <Grid item>
            <Breadcrumbs separator="›" className={classes.breadcrumbs}>
              <Typography>PicTrée 汎用事業者</Typography>
              <Typography>撮影</Typography>
              <Typography>エリア別</Typography>
            </Breadcrumbs>
          </Grid>
          <Grid item>
            <CalendarRangePicTreeCommon mDate="2026/09/01" page="pictree" pictree />
          </Grid>
        </Grid>

        <Grid container spacing={0}>
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <ByAreaSummary data={byAreaDataSummary} />
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Grid container spacing={1} className={classes.gridSection}>
          <Grid item xs={12}>
            {pageTopLoader ? (
              <div className={classes.loaderBox}>
                <img alt="" className={classes.loaderBarImg} src="/static/images/loader-bar.gif" />
              </div>
            ) : hasData ? (
              <ByAreaDetailTableCommon data={byAreaDataTable} areaLayerId={selectedAreaLayerId} />
            ) : (
              <div className={classes.noData}>
                <Chip label="No Data" style={{ color: V.textColor, backgroundColor: V.placeholderColor }} />
              </div>
            )}
          </Grid>
        </Grid>
      </C.ContentWrapper>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  pageTopLoader: state.page.pageTopLoader,
  dateRangePicTreeCommon: state.page.dateRangePicTreeCommon,
  byAreaDataSummary: state.pictreeCommon.byAreaDataSummary,
  byAreaDataTable: state.pictreeCommon.byAreaDataTable,
  selectedAreaLayerId: state.pictreeCommon.selectedAreaLayerId,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentPage: (param) => dispatch(setCurrentPage(param)),
  getByAreaDataCommon: (param) => dispatch(getByAreaDataCommon(param)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PicTreePhotoByAreaCommon);
